export default __webpack_public_path__ + "static/eser-yaratan-seyfeli-1d9851f082b5bd99aea47d40c6f19d8a.jpg";